/* eslint-disable no-undef */
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

const useSponsoredSubsStore = create(
  persist(
    (set) => ({
      sponsoredSubsLeft: -1, // default or initial value
      setsponsoredSubsLeft: (subsLeft) => {
        set({ sponsoredSubsLeft: subsLeft });

        // return subsLeft;
      },
      clearState: () => {
        set({ sponsoredSubsLeft: -1 });
      },
    }),
    {
      name: "settings-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useSponsoredSubsStore;
